import { classnames } from 'Utils/classnames/classnames.utils';

export const themes = {
  default: ({ isChecked, isDisabled }) => ({
    thRoot: classnames(
      'relative flex flex-col items-center justify-center rounded-12 border-1 border-solid bg-white p-10 text-14 font-bold transition-colors duration-250 ease-in',
      {
        'cursor-not-allowed border-grey bg-pearl': isDisabled,
        'border-lightGrey': !isChecked,
        'border-success': isChecked && !isDisabled,
      },
    ),
    thIcon: classnames('absolute end-0 top-0 m-5 text-grey', {
      'text-success': !isDisabled,
    }),
    thIconWidth: '0.625rem',
  }),
};
